import { APIGet, IAPIResponse } from "api/protocols";
import { CancelToken } from "axios";
import { formatDate } from "helpers/Helpers";
import { ITeeTime } from "redux/reducers/models/teetime";

const apiVersion = "2024-04";
const baseUrl = "/" + apiVersion + "/guest";

interface IGetTeeTimes {
  facility_id: number;
  date: Date | string;
  id?: number;
  extended?: boolean;
  turn_tee_time?: boolean;
  course_id?: number;
}

interface IGetTeeTimeCustomerResponse extends IAPIResponse {
  data: ITeeTime[];
}

//GET Customer bookings
export async function GetTeeTimesGuest(
  params: IGetTeeTimes,
  useGlobalLoader: boolean,
  cancelToken?: CancelToken,
): Promise<IGetTeeTimeCustomerResponse> {
  const convertedParams = {
    ...params,
    date: typeof params?.date === "string" ? params?.date : formatDate(params?.date)?.toString(),
  };

  return await APIGet(baseUrl + "/tee-time", convertedParams, useGlobalLoader, cancelToken);
}

interface IGetTeeTimePromotionDates {
  facility_id: number;
  start_date: string;
  end_date: string;
}

export async function GetGuestTeeTimePromotionDates(
  params: IGetTeeTimePromotionDates,
  useGlobalLoader: boolean,
  cancelToken?: CancelToken,
): Promise<IAPIResponse<string[]>> {
  return await APIGet(baseUrl + "/tee-time/promotion-dates", params, useGlobalLoader, cancelToken);
}